<template>
  <el-dialog
      :model-value="props.visible"
      title="成绩"
      width="600"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading" class="dialog-wrap">
      <div style="display: flex;flex-direction: column;align-items: center;">
        <el-progress type="circle" :percentage="percent" :color="customColor">
          <template #default="{ percentage }">
            <div style="color: #409eff;font-size: 32px;line-height: 36px;">{{ dataInfo.score }}</div>
            <div style="margin-top: 3px;font-size: 12px;line-height: 17px;">得分</div>
          </template>
        </el-progress>

        <div class="pass-res" v-if="dataInfo.isPass == '1'">
          <img src="https://static.rhkj.com/renhe_fe/other/279.png"/>
          <div>恭喜！本次考试<span class="green">通过</span>，您的评价等级为A</div>
        </div>
        <div class="pass-res" v-else-if="dataInfo.isPass == '0'">
          <img src="https://static.rhkj.com/renhe_fe/other/278.png"/>
          <div>很遗憾！本次考试<span class="red">未通过</span></div>
        </div>
      </div>

      <div class="my-footer">
        <el-button @click="onConfirm">确定</el-button>
        <el-button
            v-if="dataInfo.isPass == '0' && dataInfo.examType == '112'"
            type="primary" style="margin-right: 15px;" @click="makeUp">补考
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";
import {checkExam} from "@/api/examCenter/exam";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  dataInfo: {
    type: Object,
    required: true
  },
  examStuInfoId: { // 考试记录id
    type: String,
    default: ''
  },
  examId: { // 考试id
    type: String,
    default: ''
  },
  jumpPageConfig: {
    type: Object,
    default: () => ({
      makeUpPage: 'ExamPrepare',
      resultPage: 'ExamAnalysis',
    })
  }
})

const pageLoading = ref(false)
const customColor = ref('#409eff')

const percent = computed(() => {
  const res = props.dataInfo.score * 100 / props.dataInfo.totalPoint
  return res >= 100 ? 100 : res
})

function onOpen() {
}

const router = useRouter();

// 补考
async function makeUp() {
  if (props.dataInfo.canRetry != '1') {
    ElMessage.error('补考次数已用完')
    return
  }
  await checkExam(props.examId)
  router.replace({
    name: props.jumpPageConfig.makeUpPage,
    query: {
      id: props.examId,
      isRetry: '1',
    },
  });
}


// 确定，去结果页
function onConfirm() {
  emit('update:visible', false)
  if (props.dataInfo.correctType == 0) {
    router.replace({
      name: props.jumpPageConfig.resultPage,
      query: {
        id: props.examStuInfoId
      },
    });
  } else {
    window.close()
  }
}


const emit = defineEmits(['update:visible', 'refresh'])

function closedModal() {
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}

.dialog-wrap {
  .pass-res {
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 30px;
    color: #333333;
    margin-top: 20px;

    > img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    .red {
      color: #FF2E2E;
    }

    .green {
      color: #03B880;
    }
  }
}
</style>
